<template>
  <YSearch placeholder="Search by panel name..." v-model="sessionsFilterSettings.search" />
</template>
<script setup lang="ts">
import { YSearch } from '@yakimachief/ych-ts-component-library'
import { sessionsFilterSettings } from '@/components/UpcomingSessions/upcomingSessionsComposables'
</script>
